import React from "react";
import OrderList from "../../components/event/OrderList";

const OrdersPage = () => {
    return <OrderList/>
}

export default OrdersPage;